import {App} from '../../constants/actionType';

export function setErrorBoundary(hasError, error, info, isHandled) {
  return (dispatch) => {
    dispatch({type: App.SET_ERROR_BOUNDARY, hasError, error, info, isHandled});
  };
}

export function changeView(viewMode) {
  return (dispatch, getState) => {
    const {appState} = getState();

    if (viewMode === appState.viewMode) return;
    console.info(`access ${viewMode} menu`);
    dispatch({
      type: App.CHANGE_VIEW,
      view: viewMode,
      prevView: appState.viewMode,
    });
  };
}

export function setVersion(value) {
  return (dispatch) => {
    dispatch({type: App.SET_VERSION, value});
  };
}
